const afx = require('./afx')






const lib = {
    fx: [ {
        name: 'gain',
        display: 'gain',
        inputs: [
            {
                name: 'gain',
                type: 'knob',
                min: 0,
                max: 10,
                step: 0.01,
                value: 1
            }
          


        ],
        fn: afx.gain


    },
        {
            name: 'room',
            display: 'room',
            inputs: [
                {
                    name: 'dry_wet',
                    type: 'knob',
                    min: 0,
                    max: 1,
                    step: 0.01,
                    value: 1
                },
                {
                    name: 'type',
                    type: 'select',
                    options: [
                        {
                            name: 'telephone',
                            value: 'telephone.wav'
                        },
                        {
                            name: 'muffler',
                            value: 'muffler.wav'
                        },
                        {
                            name: 'spring',
                            value: 'spring.wav'
                        },
                        {
                            name: 'echo',
                            value: 'echo.wav'
                        },
                       ]
    
                },
    
    
    
            ],
            fn: afx.room
    
    
        }
        
        ,{
        name: 'stretch',
        display: 'stretch',
        inputs: [
            {
                name: 'stretch',
                type: 'knob',
                min: 0.001,
                max: 2,
                step: 0.001,
                value: 0.065
            }
            

        ],
        fn: afx.stretch

    },{
        name: 'moog',
        display: 'moog filter',
        inputs: [
            {
                name: 'cutoff',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.001,
                value: 0.065
            },
            {
                name: 'resonance',
                type: 'knob',
                min: 0,
                max: 4,
                step: 0.001,
                value: 0
            }

        ],
        fn: afx.moog

    },
    {
        name: 'bitcrusher',
        display: 'bitcrusher',
        inputs: [
            {
                name: 'bits',
                type: 'knob',
                min: 1,
                max: 16,
                step: 0.01,
                value: 16
            },
            {
                name: 'reduction',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 1
            }

        ],
        fn: afx.bitcrusher

    },
    {
        name: 'delay',
        display: 'delay',
        inputs: [
            {
                name: 'feedback',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.001,
                value: 0.4
            },
            {
                name: 'time',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.001,
                value: 0.5
            },
            {
                name: 'freq',
                type: 'knob',
                min: 0,
                max: 4000,
                step: 1,
                value: 1000
            }

        ],
        fn: afx.delay

    },
    {
        name: 'distortion',
        display: 'distortion',
        inputs: [
            {
                name: 'drive',
                type: 'knob',
                min: 0,
                max: 10,
                step: 0.01,
                value: 0.75
            }


        ],
        fn: afx.distortion

    },
    {
        name: 'ringmodulator',
        display: 'ring modulator',
        inputs: [
            {
                name: 'freq',
                type: 'knob',
                min: 0.1,
                max: 5000,
                step: 0.01,
                value: 2
            },
            {
                //depth
                name: 'depth',
                type: 'knob',
                min: 0,
                max: 2,
                step: 0.01,
                value: 0.5


            },
            {
                name: 'waveform',
                type: 'select',
                options: [
                    {
                        name: "sine",
                        value: "sine"
                    },
                    {
                        name: "triangle",
                        value: "triangle"
                    },
                    {
                        name: "square",
                        value: "square"
                    },
                    {
                        name: "sawtooth",
                        value: "sawtooth"
                    },


                ]

            },



        ],
        fn: afx.ringmodulator

    },
    {
        name: 'flanger',
        display: 'flanger',
        inputs: [
            {
                name: 'feedback',
                type: 'knob',
                min: 0,
                max: 0.8,
                step: 0.01,
                value: 0.5
            },
            {
                name: 'time',
                type: 'knob',
                min: 0.001,
                max: 0.04,
                step: 0.001,
                value: 0.006
            },
            {
                name: 'depth',
                type: 'knob',
                min: 0.0005,
                max: 0.005,
                step: 0.0001,
                value: 0.005
            },
            {
                name: 'speed',
                type: 'knob',
                min: 0.5,
                max: 5,
                step: 0.1,
                value: 0.5
            },
            {
                name: 'dry_wet',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 0.8
            },


        ],
        fn: afx.flanger

    },
    {
        name: 'eq',
        display: 'eq',
        inputs: [
            {
                name: 'low',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 0.5
            },
            {
                name: 'mid',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 0.5
            },
            {
                name: 'hi',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 0.5
            },



        ],
        fn: afx.eq




    },

    {
        name: 'reverb',
        display: 'reverb',
        inputs: [
            {
                name: 'dry_wet',
                type: 'knob',
                min: 0,
                max: 1,
                step: 0.01,
                value: 0.5
            },
            {
                name: 'type',
                type: 'select',
                options: [
                    {
                        name: 'AbernyteGrainSilo',
                        value: 'AbernyteGrainSilo.wav'
                    },
                    {

                        name: 'ArbroathAbbeySacristy',
                        value: 'ArbroathAbbeySacristy.wav'
                    },
                    { name: 'Basement', value: 'Basement.wav' },
                    { name: 'DomesticLivingRoom', value: 'DomesticLivingRoom.wav' },
                    {
                        name: 'ElvedenHallLordsCloakroom',
                        value: 'ElvedenHallLordsCloakroom.wav'
                    },
                    {
                        name: 'ElvedenHallMarbleHall',
                        value: 'ElvedenHallMarbleHall.wav'
                    },
                    {
                        name: 'ElvedenHallSmokingRoom',
                        value: 'ElvedenHallSmokingRoom.wav'
                    },
                    {
                        name: 'ElvedenHallVisitorsCloakroom',
                        value: 'ElvedenHallVisitorsCloakroom.wav'
                    },
                    {
                        name: 'EmptyApartmentBedroom',
                        value: 'EmptyApartmentBedroom.wav'
                    },
                    {
                        name: 'ErrolBrickworksKiln',
                        value: 'ErrolBrickworksKiln.wav'
                    },
                    {
                        name: 'FalklandPalaceRoyalTennisCourt',
                        value: 'FalklandPalaceRoyalTennisCourt.wav'
                    },
                    { name: 'HamiltonMausoleum', value: 'HamiltonMausoleum.wav' },
                    { name: 'InsidePiano', value: 'InsidePiano.wav' },
                    { name: 'KinoullAisle', value: 'KinoullAisle.wav' },
                    {
                        name: 'LadyChapelStAlbansCathedral',
                        value: 'LadyChapelStAlbansCathedral.wav'
                    },
                    { name: 'MaesHowe', value: 'MaesHowe.wav' },
                    {
                        name: 'MidiverbMark2Preset29',
                        value: 'MidiverbMark2Preset29.wav'
                    },
                    {
                        name: 'PerthCityHallBalcony',
                        value: 'PerthCityHallBalcony.wav'
                    },
                    {
                        name: 'PurnodesRailroadTunnel',
                        value: 'PurnodesRailroadTunnel.wav'
                    },
                    {
                        name: 'R1NuclearReactorHall',
                        value: 'R1NuclearReactorHall.wav'
                    },
                    {
                        name: 'SaintLawrenceChurchMolenbeekWersbeekBelgium',
                        value: 'SaintLawrenceChurchMolenbeekWersbeekBelgium.wav'
                    },
                    {
                        name: 'SampleBachCMinorPrelude',
                        value: 'SampleBachCMinorPrelude.wav'
                    },
                    {
                        name: 'SpokaneWomansClub',
                        value: 'SpokaneWomansClub.wav'
                    },
                    {
                        name: 'SportsCentreUniversityOfYork',
                        value: 'SportsCentreUniversityOfYork.wav'
                    },
                    { name: 'StAndrewsChurch', value: 'StAndrewsChurch.wav' },
                    {
                        name: 'StMarysAbbeyReconstructionPhase1',
                        value: 'StMarysAbbeyReconstructionPhase1.wav'
                    },
                    {
                        name: 'StMarysAbbeyReconstructionPhase2',
                        value: 'StMarysAbbeyReconstructionPhase2.wav'
                    },
                    {
                        name: 'StMarysAbbeyReconstructionPhase3',
                        value: 'StMarysAbbeyReconstructionPhase3.wav'
                    },
                    {
                        name: 'StPatricksChurchPatringtonPosition1',
                        value: 'StPatricksChurchPatringtonPosition1.wav'
                    },
                    {
                        name: 'StPatricksChurchPatringtonPosition2',
                        value: 'StPatricksChurchPatringtonPosition2.wav'
                    },
                    {
                        name: 'StPatricksChurchPatringtonPosition3',
                        value: 'StPatricksChurchPatringtonPosition3.wav'
                    },
                    {
                        name: 'StairwayUniversityOfYork',
                        value: 'StairwayUniversityOfYork.wav'
                    },
                    {
                        name: 'TerrysFactoryWarehouse',
                        value: 'TerrysFactoryWarehouse.wav'
                    },
                    {
                        name: 'TerrysTypingRoom',
                        value: 'TerrysTypingRoom.wav'
                    },
                    {
                        name: 'TyndallBruceMonument',
                        value: 'TyndallBruceMonument.wav'
                    },
                    { name: 'UndergroundCarPark', value: 'UndergroundCarPark.wav' },
                    { name: 'YorkMinster', value: 'YorkMinster.wav' }]

            },



        ],
        fn: afx.reverb




    },

    {
        name: 'pitshifter',
        display: 'pitshifter',
        inputs: [
            {
                name: 'ratio',
                type: 'knob',
                value: 1,
                min: 0.5,
                max: 2,
                step: 0.1

            },
            {
                name: 'overlap',
                type: 'knob',
                value: 0.5,
                min: 0,
                max: 0.75,
                step: 0.01

            },
            {
                name: 'grain',
                type: 'select',
                options: [
                    {
                        name: 256,
                        value: 256
                    },
                    {
                        name: 512,
                        value: 512
                    },
                    {
                        name: 1024,
                        value: 1024
                    },
                    {
                        name: 2048,
                        value: 2048
                    },
                    {
                        name: 4096,
                        value: 4096
                    },
                    {
                        name: 8192,
                        value: 8192
                    }


                ]

            },


        ],
        fn: afx.pitshifter

    },
    {
        name: 'tremolo',
        display: 'tremolo',
        inputs: [
            {
                name: 'speed',
                type: 'knob',
                value: 1,
                min: 0,
                max: 20,
                step: 0.01

            },
            {
                name: 'depth',
                type: 'knob',
                value: 0.5,
                min: 0,
                max: 1,
                step: 0.01

            }





        ],
        fn: afx.tremolo

    },
    {
        name: 'filter',
        display: 'filter',
        inputs: [
            {
                name: 'frequency',
                type: 'knob',
                value: 0.4,
                min: 0,
                max: 1,
                step: 0.0001

            },
            {
                name: 'q',
                type: 'knob',
                value: 0.2,
                min: 0,
                max: 1,
                step: 0.0001

            },
            {
                name: 'mode',
                type: 'select',
                options: [
                    {
                        name: "lowpass",
                        value: "lowpass"
                    },
                    {
                        name: "highpass",
                        value: "highpass"
                    },
                    {
                        name: "bandpass",
                        value: "bandpass"
                    },
                    {
                        name: "notch",
                        value: "notch"
                    },
                    {
                        name: "allpass",
                        value: "allpass"
                    }

                ]


            },





        ],
        fn: afx.filter

    },
     {
        name: 'softclipper',
        display: 'soft clipper',
        inputs: [
            {
                name: 'threshold',
                type: 'knob',
                value: 0.4,
                min: 0.0001,
                max: 1,
                step: 0.0001

            },
            {
                name: 'oversample',
                type: 'select',
                options: [
                    {
                        name: "none",
                        value: 1                    },
                    {
                        name: "2x",
                        value: 2
                    },
                    {
                        name: "4x",
                        value: 4
                    },
                    {
                        name: "8x",
                        value: 8
                    },
                    {
                        name: "16x",
                        value: 16
                    },
                    {
                        name: "32x",
                        value: 32
                    }

                ]

            },
        ],
        fn: afx.softclipper
    },
    // {
    //     name: 'chorus',
    //     display: 'chorus',
    //     inputs: [
    //         {
    //             name: 'rate',
    //             type: 'knob',
    //             value: 1.5,
    //             min: 0.01,
    //             max: 8,
    //             step: 0.0001
    //         },
    //         {
    //             name: 'depth',
    //             type: 'knob',
    //             value: 0.5,
    //             min: 0,
    //             max: 1,
    //             step: 0.01
    //         },
    //         {
    //             name: 'feedback',
    //             type: 'knob',
    //             value: 0.2,
    //             min: 0,
    //             max: 1,
    //             step: 0.01
    //         }
    //     ],
    //     fn: afx.chorus
    // },
    {
        name: 'compressor',
        display: 'compressor',
        inputs: [
            { name: 'threshold', type: 'knob', min: 0, max: 100, step: 1, value: 24 },
            { name: 'knee', type: 'knob', min: 0, max: 40, step: 1, value: 30 },
            { name: 'ratio', type: 'knob', min: 1, max: 20, step: 1, value: 12 },
            { name: 'attack', type: 'knob', min: 0, max: 1, step: 0.001, value: 0.003 },
            { name: 'release', type: 'knob', min: 0, max: 1, step: 0.001, value: 0.25 }
        ],
        fn: afx.compressor
    },
    {
        name: 'autopanner',
        display: 'auto panner',
        inputs: [
            { name: 'rate', type: 'knob', min: 0.01, max: 20, step: 0.01, value: 2 },
            { name: 'depth', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.8 },
            {
                name: 'waveform',
                type: 'select',
                options: [
                    { name: 'sine', value: 'sine' },
                    { name: 'triangle', value: 'triangle' },
                    { name: 'square', value: 'square' }
                ]
            },
            { name: 'stereoPhase', type: 'knob', min: 0, max: 180, step: 1, value: 0 }
        ],
        fn: afx.autopanner
    },
    {
        name: 'bitcrusherdisto',
        display: 'bitcrusher disto',
        inputs: [
            { name: 'bitDepth', type: 'knob', min: 1, max: 16, step: 1, value: 8 },
            { name: 'downsample', type: 'knob', min: 1, max: 32, step: 1, value: 1 },
            { name: 'drive', type: 'knob', min: 0, max: 2, step: 0.01, value: 1 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.bitcrusherdisto
    },
    {
        name: 'canalplus',
        display: 'canal plus',
        inputs: [
            { name: 'mode', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
            { name: 'carrierFreq', type: 'knob', min: 50, max: 8000, step: 1, value: 1200 },
            { name: 'gateRate', type: 'knob', min: 1, max: 400, step: 1, value: 40 },
            { name: 'gateDuty', type: 'knob', min: 1, max: 99, step: 1, value: 50 },
            { name: 'decode', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
            { name: 'outGain', type: 'knob', min: 0, max: 4, step: 0.01, value: 0.9 }
        ],
        fn: afx.canalplus
    },
    {
        name: 'chorus1',
        display: 'chorus',
        inputs: [
            { name: 'depth', type: 'knob', min: 1, max: 10, step: 0.1, value: 5 },
            { name: 'rate', type: 'knob', min: 0.01, max: 5, step: 0.01, value: 0.25 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.2, step: 0.01, value: 0.05 }
        ],
        fn: afx.chorus1
    },
    {
        name: 'dubdelay',
        display: 'dub delay',
        inputs: [
            { name: 'feedback', type: 'knob', min: 0, max: 1, step: 0.001, value: 0.4 },
            { name: 'time', type: 'knob', min: 0, max: 1, step: 0.001, value: 0.5 },
            { name: 'freq', type: 'knob', min: 0, max: 4000, step: 1, value: 1000 },
            {
                name: 'filterType',
                type: 'select',
                options: [
                    { name: 'lowpass', value: 'lowpass' },
                    { name: 'highpass', value: 'highpass' },
                    { name: 'bandpass', value: 'bandpass' },
                    { name: 'allpass', value: 'allpass' }
                ]
            },
            { name: 'dry_wet', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.8 }
        ],
        fn: afx.dubdelay
    },
    {
        name: 'flanger2',
        display: 'flanger2',
        inputs: [
            { name: 'depth', type: 'knob', min: 1, max: 10, step: 0.1, value: 5 },
            { name: 'rate', type: 'knob', min: 0.1, max: 5, step: 0.01, value: 0.25 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.3 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.flanger2
    },
    {
        name: 'frequencyshifter',
        display: 'frequency shifter',
        inputs: [
            { name: 'shift', type: 'knob', min: -2000, max: 2000, step: 1, value: 100 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.3 },
            { name: 'lfoRate', type: 'knob', min: 0, max: 10, step: 0.01, value: 0 },
            { name: 'lfoDepth', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.frequencyshifter
    },
    {
        name: 'gate',
        display: 'gate/expander',
        inputs: [
            { name: 'threshold', type: 'knob', min: -60, max: 0, step: 1, value: -40 },
            { name: 'ratio', type: 'knob', min: 1, max: 20, step: 0.1, value: 10 },
            { name: 'attack', type: 'knob', min: 0, max: 100, step: 0.1, value: 1 },
            { name: 'release', type: 'knob', min: 10, max: 1000, step: 1, value: 100 },
            { name: 'hold', type: 'knob', min: 0, max: 500, step: 1, value: 50 },
            { name: 'sidechainFreq', type: 'knob', min: 20, max: 20000, step: 1, value: 1000 }
        ],
        fn: afx.gate
    },
    {
        name: 'glitchdelay',
        display: 'glitch delay',
        inputs: [
            { name: 'pitchLfoFreq', type: 'knob', min: 0.1, max: 20, step: 0.1, value: 5 },
            { name: 'pitchLfoDepth', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.2 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.3 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.glitchdelay
    },
    {
        name: 'granularpitch',
        display: 'granular pitch',
        inputs: [
            { name: 'grainSize', type: 'knob', min: 10, max: 100, step: 1, value: 30 },
            { name: 'pitchShift', type: 'knob', min: 0.5, max: 2, step: 0.01, value: 1 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.3 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.granularpitch
    },
    {
        name: 'moogfilter',
        display: 'moog filter (worklet)',
        inputs: [
            { name: 'cutoff', type: 'knob', min: 0, max: 1, step: 0.001, value: 0.065 },
            { name: 'resonance', type: 'knob', min: 0, max: 4, step: 0.001, value: 0 }
        ],
        fn: afx.moogfilter
    },
    {
        name: 'noiseverb',
        display: 'noise verb',
        inputs: [
            { name: 'dry_wet', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            {
                name: 'type',
                type: 'select',
                options: [
                    { name: 'white noise', value: 0 },
                    { name: 'pink noise', value: 1 },
                    { name: 'brown noise', value: 2 },
                    { name: 'blue noise', value: 3 },
                    { name: 'perlin noise', value: 4 }
                ]
            }
        ],
        fn: afx.noiseverb
    },
    {
        name: 'phaser',
        display: 'phaser',
        inputs: [
            { name: 'rate', type: 'knob', min: 0.01, max: 10, step: 0.01, value: 0.5 },
            { name: 'depth', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.7 },
            { name: 'stages', type: 'knob', min: 2, max: 12, step: 1, value: 6 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.5 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.phaser
    },
    {
        name: 'resonantFilterBank',
        display: 'resonant filter bank',
        inputs: [
            { name: 'LP_88hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '125Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '175Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '250Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '350Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '500Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '750Hz', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '1k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '1_4k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '2k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '2_8k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '4k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: '5_6k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: 'HP_7k', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 }
        ],
        fn: afx.resonantFilterBank
    },
    {
        name: 'spectralfreeze',
        display: 'spectral freeze',
        inputs: [
            { name: 'freeze', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
            { name: 'fadeTime', type: 'knob', min: 10, max: 1000, step: 1, value: 100 },
            { name: 'shimmer', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: 'decay', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.1 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.spectralfreeze
    },
    {
        name: 'stereowidener',
        display: 'stereo widener',
        inputs: [
            { name: 'width', type: 'knob', min: 0, max: 2, step: 0.01, value: 1 },
            { name: 'lowFreqMono', type: 'knob', min: 0, max: 500, step: 1, value: 120 },
            { name: 'delay', type: 'knob', min: 0, max: 50, step: 0.1, value: 15 },
            { name: 'phase', type: 'knob', min: 0, max: 180, step: 1, value: 0 }
        ],
        fn: afx.stereowidener
    },
    {
        name: 'tapesaturation',
        display: 'tape saturation',
        inputs: [
            { name: 'drive', type: 'knob', min: 0, max: 10, step: 0.1, value: 3 },
            { name: 'saturation', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'wow', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.2 },
            { name: 'flutter', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.1 },
            { name: 'bias', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.7 }
        ],
        fn: afx.tapesaturation
    },
    {
        name: 'pvshift',
        display: 'phase vocoder shift',
        inputs: [
            { name: 'ratio', type: 'knob', min: 0.5, max: 2, step: 0.01, value: 1 },
            {
                name: 'grain',
                type: 'select',
                options: [
                    { name: 512, value: 512 },
                    { name: 1024, value: 1024 },
                    { name: 2048, value: 2048 },
                    { name: 4096, value: 4096 }
                ]
            }
        ],
        fn: afx.pvshift
    },
    {
        name: 'procreverb',
        display: 'procedural reverb',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.3 },
            { name: 'time', type: 'knob', min: 0.1, max: 10, step: 0.1, value: 3 },
            { name: 'decay', type: 'knob', min: 0.1, max: 10, step: 0.1, value: 2 },
            { name: 'delay', type: 'knob', min: 0, max: 1, step: 0.01, value: 0 },
            { name: 'reverse', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
            {
                name: 'noise',
                type: 'select',
                options: [
                    { name: 'white', value: 0 },
                    { name: 'pink', value: 1 },
                    { name: 'brown', value: 2 },
                    { name: 'blue', value: 3 }
                ]
            },
            {
                name: 'filterType',
                type: 'select',
                options: [
                    { name: 'lowpass', value: 'lowpass' },
                    { name: 'highpass', value: 'highpass' },
                    { name: 'bandpass', value: 'bandpass' },
                    { name: 'allpass', value: 'allpass' }
                ]
            },
            { name: 'filterFreq', type: 'knob', min: 20, max: 20000, step: 1, value: 2200 },
            { name: 'filterQ', type: 'knob', min: 0, max: 10, step: 0.1, value: 1 }
        ],
        fn: afx.procreverb
    },

    // ============ mdrone-ported effects ============

    {
        name: 'shimmer',
        display: 'shimmer',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.4 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.9, step: 0.01, value: 0.3 }
        ],
        fn: afx.shimmer
    },
    {
        name: 'freeze',
        display: 'freeze',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'freeze', type: 'knob', min: 0, max: 1, step: 1, value: 0 },
            { name: 'size', type: 'knob', min: 0.005, max: 1, step: 0.005, value: 1 },
            { name: 'position', type: 'knob', min: 0, max: 1, step: 0.005, value: 0 }
        ],
        fn: afx.freeze
    },
    {
        name: 'halo',
        display: 'halo',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.3 },
            { name: 'tilt', type: 'knob', min: -1, max: 1, step: 0.01, value: 0 }
        ],
        fn: afx.halo
    },
    {
        name: 'sub',
        display: 'sub synth',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'tracking', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.3 },
            {
                name: 'octave',
                type: 'select',
                options: [
                    { name: '-1 oct', value: 2 },
                    { name: '-2 oct', value: 4 }
                ]
            },
            {
                name: 'wave',
                type: 'select',
                options: [
                    { name: 'sine', value: 'sine' },
                    { name: 'triangle', value: 'triangle' },
                    { name: 'square', value: 'square' },
                    { name: 'saw', value: 'saw' }
                ]
            }
        ],
        fn: afx.sub
    },
    {
        name: 'tape',
        display: 'tape',
        inputs: [
            { name: 'drive', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'bump', type: 'knob', min: 0, max: 12, step: 0.1, value: 4 },
            { name: 'rolloff', type: 'knob', min: 1000, max: 20000, step: 100, value: 8000 }
        ],
        fn: afx.tape
    },
    {
        name: 'comb',
        display: 'comb filter',
        inputs: [
            { name: 'freq', type: 'knob', min: 20, max: 2000, step: 1, value: 220 },
            { name: 'feedback', type: 'knob', min: 0, max: 0.95, step: 0.01, value: 0.8 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 }
        ],
        fn: afx.comb
    },
    {
        name: 'formant',
        display: 'formant',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'q', type: 'knob', min: 1, max: 20, step: 0.1, value: 8 },
            {
                name: 'vowel',
                type: 'select',
                options: [
                    { name: 'ah', value: 'ah' },
                    { name: 'ee', value: 'ee' },
                    { name: 'ih', value: 'ih' },
                    { name: 'eh', value: 'eh' },
                    { name: 'oh', value: 'oh' },
                    { name: 'oo', value: 'oo' },
                    { name: 'uh', value: 'uh' }
                ]
            }
        ],
        fn: afx.formant
    },
    {
        name: 'wow',
        display: 'wow/flutter',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'wowRate', type: 'knob', min: 0.1, max: 5, step: 0.01, value: 0.7 },
            { name: 'wowAmt', type: 'knob', min: 0, max: 0.02, step: 0.0001, value: 0.005 },
            { name: 'flutRate', type: 'knob', min: 1, max: 20, step: 0.1, value: 6 },
            { name: 'flutAmt', type: 'knob', min: 0, max: 0.005, step: 0.00001, value: 0.0008 }
        ],
        fn: afx.wow
    },
    {
        name: 'hall',
        display: 'hall',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.4 },
            { name: 'decay', type: 'knob', min: 0.1, max: 1.5, step: 0.01, value: 0.9 }
        ],
        fn: afx.hall
    },
    {
        name: 'cistern',
        display: 'cistern',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'time', type: 'knob', min: 5, max: 28, step: 0.5, value: 20 },
            { name: 'damp', type: 'knob', min: 200, max: 8000, step: 50, value: 2000 }
        ],
        fn: afx.cistern
    },
    {
        name: 'granular',
        display: 'granular',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'density', type: 'knob', min: 0.1, max: 10, step: 0.1, value: 3 }
        ],
        fn: afx.granular
    },
    {
        name: 'graincloud',
        display: 'grain cloud',
        inputs: [
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 0.5 },
            { name: 'rate', type: 'knob', min: 0.1, max: 10, step: 0.1, value: 2 }
        ],
        fn: afx.graincloud
    },
    {
        name: 'hrtf',
        display: 'hrtf panner',
        inputs: [
            { name: 'azimuth', type: 'knob', min: -90, max: 90, step: 1, value: 0 },
            { name: 'elevation', type: 'knob', min: -45, max: 90, step: 1, value: 0 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 1 }
        ],
        fn: afx.hrtf
    },
    {
        name: 'binauralfir',
        display: 'binaural FIR',
        inputs: [
            { name: 'azimuth', type: 'knob', min: -180, max: 180, step: 1, value: 0 },
            { name: 'elevation', type: 'knob', min: -90, max: 90, step: 1, value: 0 },
            { name: 'distance', type: 'knob', min: 1, max: 50, step: 0.5, value: 1 },
            { name: 'mix', type: 'knob', min: 0, max: 1, step: 0.01, value: 1 }
        ],
        fn: afx.binauralfir
    }

]




            

            

}


module.exports = lib